// extracted by mini-css-extract-plugin
module.exports = {"cart-notices":"cartNotices_cart-notices__moHug"};